import type { Ref } from 'react';
import { forwardRef } from 'react';
import FormLabel from './FormLabel';
import MultiTextInput from './MultiTextInput';
import type { FormLabelVariant } from './FormLabel';
import type { MultiTextInputProps } from './MultiTextInput';

type LabeledMultiTextInputProps = MultiTextInputProps & {
  /**
   * ID is mandatory for the label to work, because there are button elements inside the label.
   */
  id: string;
  /**
   * Optionally style the label.
   */
  labelVariant?: FormLabelVariant;
};

/**
 * Labeled version of the MultiTextInput.
 * See MultiTextInput for props and more details.
 */
const LabeledMultiTextInput = forwardRef<HTMLInputElement, LabeledMultiTextInputProps>(({
  id,
  label,
  isRequired,
  labelVariant,
  ...props
}: LabeledMultiTextInputProps, ref: Ref<HTMLInputElement>) => (
  <FormLabel
    label={label}
    htmlFor={id}
    variant={labelVariant}
  >
    <MultiTextInput
      ref={ref}
      id={id}
      label={label}
      isRequired={isRequired}
      {...props} // eslint-disable-line react/jsx-props-no-spreading
    />
  </FormLabel>
));

export default LabeledMultiTextInput;
